import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import LandingPageSkeleton from '../components/skeletons/LandingPageSkeleton';

const featureCards = [
  { title: 'Connect', description: 'Network with alumni from your batch and other years' },
  { title: 'Opportunities', description: 'Find and post job opportunities exclusively for alumni and the juniors' },
  { title: 'Grow', description: 'Build your professional profile and showcase achievements' },
];

const LandingPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [loadingPercentage, setLoadingPercentage] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <LandingPageSkeleton />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white dark:from-gray-900 dark:to-gray-800">
      <div className="container mx-auto px-4 py-16">
        <div className="text-center mb-16">
          {/* Add logo image */}
          <div className="flex justify-center mb-6">
            <img 
              src="/favicon-logo.png" 
              alt="RCOEM Logo" 
              className="h-24 w-auto"
            />
          </div>
          
          <h2 className="text-2xl font-semibold text-blue-800 dark:text-blue-400 mb-4">
            Ramdeobaba University,Nagpur(RBU)
          </h2>
          <p className="text-lg text-blue-600 dark:text-blue-300 mb-8">
            (An Autonomous Institution)
          </p>
          <h1 className="text-5xl font-bold text-gray-900 dark:text-white mb-6">
            Welcome to Alumni Portal
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300 mb-8">
            Connect with fellow alumni, find job opportunities, and grow your professional network
          </p>
          <div className="flex justify-center gap-4">
            <button
              onClick={() => navigate('/auth?mode=login')}
              className="px-8 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Login
            </button>
            <button
              onClick={() => navigate('/auth?mode=signup')}
              className="px-8 py-3 bg-white text-blue-600 border-2 border-blue-600 rounded-lg hover:bg-blue-50 transition-colors"
            >
              Sign Up
            </button>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mt-16">
          {featureCards.map((card) => (
            <div key={card.title} className="p-6 bg-white dark:bg-gray-800 rounded-xl shadow-md dark:shadow-gray-900">
              <h3 className="text-xl font-semibold mb-4 dark:text-white">{card.title}</h3>
              <p className="text-gray-600 dark:text-gray-300">{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
